import $store from '@/store'

/**
 * ui 설정 정보를 리셋해야하는 경우
 */
export default (to, from, next) => {
  $store.commit('ui/setFootless', null)

  // 헤더 버튼 커스텀 액션 리셋
  $store.commit('ui/header/setBackAction', null)
  $store.commit('ui/header/setCloseAction', to.meta?.ui?.header?.closeAction)
  $store.commit('ui/header/setHeadless', to.meta?.ui?.headless)

  // snackbar 닫기
  $store.commit('ui/toast/close')

  next()
}
